import PropTypes from "prop-types"
import React, { useState, useEffect } from "react"

import { connect } from "react-redux"
import { Link } from "react-router-dom"

import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu"

import logo from "../../assets/images/logo_igarashi_without_text.svg"
import logoLightSvg from "../../assets/images/logo-light.svg"

//i18n
import { withTranslation } from "react-i18next"

// Redux Store
import {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
} from "../../store/actions"
import { getInfoMeAPI } from "helpers/users_backend_helper"
import useWindowDimensions from "util/getWindowsDimension"

const Header = props => {
  const [isMenuOpened, setIsMenuOpened] = useState(false)
  const { width } = useWindowDimensions()
  function tToggle() {
    var body = document.body
    if (window.screen.width <= 992) {
      body.classList.toggle("sidebar-enable")
      // body.classList.toggle("vertical-collpsed")
    } else {
      body.classList.toggle("vertical-collpsed")
      body.classList.toggle("sidebar-enable")
    }
  }

  const openMenu = () => {
    setIsMenuOpened(prevState => !prevState)

    if (document.body) {
      if (isMenuOpened) {
        document.body.classList.remove("sidebar-enable")
      } else {
        document.body.classList.add("sidebar-enable")
      }
    }
  }

  // const [myInfo, setMyInfo] = useState(null)

  // const fetchMyInfo = async () => {
  //   try {
  //     let me = await getInfoMeAPI()
  //     setMyInfo(me?.data)
  //   } catch (error) {
  //     console.log("error: ", error.response)
  //     if (error.response.status === 403) {
  //       localStorage.removeItem("authUser")
  //       window.location.href = "/login"
  //     }
  //   }
  // }

  // useEffect(() => {
  //   fetchMyInfo()
  // }, [])

  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex">
            <div className="navbar-brand-box d-lg-none">
              <Link to="/" className="logo logo-dark">
                <span className="logo-sm">
                  <img src={logo} alt="" height="22" />
                </span>
              </Link>

              <Link to="/" className="logo logo-light">
                <span className="logo-sm">
                  <img src={logo} alt="" height="22" />
                </span>
              </Link>
            </div>
            {width >= 992 && width <= 1400 && (
              <div className="navbar-brand-box">
                <Link to="/" className="logo logo-dark">
                  <span className="logo-sm">
                    <img src={logo} alt="" height="22" />
                  </span>
                </Link>
              </div>
            )}
            {width > 1400 && (
              <button
                type="button"
                onClick={() => {
                  tToggle()
                }}
                className="btn btn-sm px-3 font-size-16 header-item"
                id="vertical-menu-btn"
                style={{ cursor: "pointer" }}
              >
                <i className="fa fa-fw fa-bars" />
              </button>
            )}
            {width <= 1400 && (
              <button
                type="button"
                onClick={() => {
                  openMenu()
                }}
                className="btn btn-sm px-3 font-size-16 header-item"
                id="vertical-menu-btn"
                style={{ cursor: "pointer" }}
              >
                <i className="fa fa-fw fa-bars" />
              </button>
            )}
          </div>
          <div className="d-flex">
            <ProfileMenu />
          </div>
        </div>
      </header>
    </React.Fragment>
  )
}

Header.propTypes = {
  changeSidebarType: PropTypes.func,
  leftMenu: PropTypes.any,
  leftSideBarType: PropTypes.any,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func,
}

const mapStatetoProps = state => {
  const { layoutType, showRightSidebar, leftMenu, leftSideBarType } =
    state.Layout
  return { layoutType, showRightSidebar, leftMenu, leftSideBarType }
}

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
})(withTranslation()(Header))
